import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import { CommonService } from '../../../services/common.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-notification-template',
  templateUrl: './notification-template.page.html',
  styleUrls: ['./notification-template.page.scss'],
})
export class NotificationTemplatePage implements OnInit {

  @ViewChild('textarea') element: ElementRef;

  notificationTemplateForm: FormGroup;
  submitted = false;
  notificationTemplateId: string;
  notificationTemplate: any = {};
  notificationTemplates: any = {};
  showPage: boolean = false;
  title : any;

  locale : any;
  tempLocale: any;

  breadcrumb: any = {
    NotificationTemplateName: null
  }

  constructor(private router: Router, private location: Location, private route: ActivatedRoute, private formBuilder: FormBuilder, private _apiService: ApiService, public _commonService: CommonService) { }

  ngOnInit() {
    this.notificationTemplateForm = this.formBuilder.group({
      Title: [''],
      Description: [''],
      Subject: ['', Validators.required],
      Text: ['', Validators.required]
    }
    );
  }

  ionViewDidEnter() {
    this.notificationTemplateId = this.route.snapshot.paramMap.get('id');
    this.locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
    this.tempLocale = this.locale;
    if (this.notificationTemplateId == '0') {
      this.notificationTemplateId = null;
    }
    if (this.notificationTemplateId) {
      this.getnotificationTemplateDetails();
    } else {
      this.showPage = true;
      this.notificationTemplates =
        {
          NotificationTemplateId: this.notificationTemplateId,
          Translations: [
            {
              Title: "",
              Description: "",
              Subject: "",
              Text: "",
              LocaleId: this.locale,
            }
          ]
        }
      this.getLocales();
    }
  }

  async getLocales() {
    try {
      if (localStorage.domainLocales) {
        this.notificationTemplate.AllLocales = JSON.parse(localStorage.domainLocales);
      } else {
        let localeData = await this._apiService.getDomainLocales('', 1, 0);
        this.notificationTemplate.AllLocales = localeData.body;
        localStorage.domainLocales = JSON.stringify(localeData.body);
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getnotificationTemplateDetails() {
    try {
      this._commonService.presentLoading();
      let data = await this._apiService.getNotificationTemplate(this.notificationTemplateId);
      this.notificationTemplates = data.body;
      await this.getLocales();

      this._commonService.log(this.notificationTemplates, this._commonService.LOG);
      
      let template = this.notificationTemplates.Translations.find(x => x.LocaleId == this.locale);
      this.title = template.Title;
      this.breadcrumb.NotificationTemplateName = template.Title
      this.notificationTemplateForm.patchValue({
        Title: template.Title,
        Description: template.Description,
        Subject: template.Subject,
        Text: template.Text
      });

      this._commonService.dismiss();
      this.notificationTemplateForm.updateValueAndValidity();
      this.showPage = true;
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  get f() { return this.notificationTemplateForm.controls; }

  async  onSubmit() {
    this.submitted = true;
    if (this.notificationTemplateForm.invalid) {
      this._commonService.scrollToError();
      return;
    }
    this._commonService.presentLoading();
    try {
        let tempTemplate = this.notificationTemplates.Translations.find(x => x.LocaleId == this.locale);
        tempTemplate.Title = this.notificationTemplateForm.value.Title;
        tempTemplate.Description = this.notificationTemplateForm.value.Description;
        tempTemplate.Subject = this.notificationTemplateForm.value.Subject;
        tempTemplate.Text = this.notificationTemplateForm.value.Text;
        this.notificationTemplates.NotificationTemplateId = this.notificationTemplateId;

        let res = await this._apiService.postNotificationTemplate(this.notificationTemplates)
        if(res.id){
          this.notificationTemplateId = res.id;
          this.location.replaceState('maintenance/notificationtemplates/' + this.notificationTemplateId);
        }
        this._commonService.log(this.notificationTemplates, this._commonService.LOG);
        this._commonService.dismiss();
        this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
        this.submitted = false;
        //this.router.navigate(['/notificationtemplates']);
    }
    catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
      this._commonService.dismiss();
    }
  }

  onReset() {
    this.submitted = false;
    this.notificationTemplateForm.reset();
  }

  ionViewDidLeave() {
    this.onReset();
  }

  delete() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          await this._apiService.deleteNotificationTemplate(this.notificationTemplateId);
          this._commonService.dismiss();
          this._commonService.log(res, this._commonService.LOG);
          this.goBack();
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }

  goBack() {
    this._commonService.goBack('maintenance/notificationtemplates');
  }

  changeLocale(){
    if(this.notificationTemplateId){
      let tempTemplate = this.notificationTemplates.Translations.find(x => x.LocaleId == this.tempLocale);
      tempTemplate.Title = this.notificationTemplateForm.value.Title;
      tempTemplate.Description = this.notificationTemplateForm.value.Description;
      tempTemplate.Subject = this.notificationTemplateForm.value.Subject;
      tempTemplate.Text = this.notificationTemplateForm.value.Text;
      this.tempLocale = this.locale;
      let template = this.notificationTemplates.Translations.find(x => x.LocaleId == this.locale);
      if(template){
        this.notificationTemplateForm.patchValue({
          Title: template.Title,
          Description: template.Description,
          Subject: template.Subject,
          Text: template.Text
        });
      }else{
        this.notificationTemplates.Translations.push({
          Title: "",
          Description: "",
          Subject: "",
          Text: "",
          LocaleId: this.locale,
        });
        this.onReset();
        let textarea = document.querySelector('.textarea');
        if (textarea) textarea.classList.remove("item-has-value");
      }
    }else{
      let tempTemplate = this.notificationTemplates.Translations.find(x => x.LocaleId == this.tempLocale);
      if(tempTemplate){
        tempTemplate.Title = this.notificationTemplateForm.value.Title;
        tempTemplate.Description = this.notificationTemplateForm.value.Description;
        tempTemplate.Subject = this.notificationTemplateForm.value.Subject;
        tempTemplate.Text = this.notificationTemplateForm.value.Text;
        this.tempLocale = this.locale;

        let template = this.notificationTemplates.Translations.find(x => x.LocaleId == this.locale);
        if (template){
          this.notificationTemplateForm.patchValue({
            Title: template.Title,
            Description: template.Description,
            Subject: template.Subject,
            Text: template.Text
          });
        }
        else{
          this.notificationTemplates.Translations.push({
            Title: "",
            Description: "",
            Subject: "",
            Text: "",
            LocaleId: this.locale,
          });
          this.onReset();
          let textarea = document.querySelector('.textarea');
          if (textarea) textarea.classList.remove("item-has-value");
          this.tempLocale = this.locale;
        }
      }
    }
  }

  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
          this.onSubmit();
          break;
      case "delete":
          this.delete();
          break;
      case "backToList":
          this.goBack();
          break;
      case "backToMain":
          this.router.navigate(['maintenance'], { replaceUrl: true })
          break;
      case "back":
          this.goBack();
          break;
      }
      
  }

}
